// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleItemGroups-module__container--uHLX3{display:flex;gap:5px}.ArticleItemGroups-module__container--uHLX3 .ArticleItemGroups-module__group-amount--EAoAW{color:#070707;font-size:11px;font-weight:600}.ArticleItemGroups-module__container--uHLX3 .ArticleItemGroups-module__item--GLewp:not(:last-child):after{content:"|";margin-left:3px;color:rgba(7,7,7,.1)}.ArticleItemGroups-module__container--uHLX3 .ArticleItemGroups-module__item--GLewp .ArticleItemGroups-module__name--x9SzF{color:#070707;font-size:11px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticleItemGroups-module__container--uHLX3`,
	"group-amount": `ArticleItemGroups-module__group-amount--EAoAW`,
	"groupAmount": `ArticleItemGroups-module__group-amount--EAoAW`,
	"item": `ArticleItemGroups-module__item--GLewp`,
	"name": `ArticleItemGroups-module__name--x9SzF`
};
export default ___CSS_LOADER_EXPORT___;
